import React, { Component } from 'react';
import UsersStore from '../store/UsersStore';

const usersDb = new UsersStore('usersDb');

export const withUsers = (WrappedComponent) => class WithUsers extends Component {
    state = {
      users: [],
    };

    load = () => {
      usersDb.load((users) => {
        if (!users) {
          return;
        }
        this.setState({
          users,
        });
      });
    };

    fetch = (credentials, onFetched = () => {}, onError) => {
      const onSuccess = () => {
        this.load();
        onFetched();
      };

      return usersDb.fetchFromSalesforceAndSave({
        credentials,
        onSuccess,
        onError,
      });
    };

    render() {
      return (
        <WrappedComponent
          users={{
            value: this.state.users,
            fetch: this.fetch,
            load: this.load,
          }}
          {...this.props}
        />
      );
    }
};

export default withUsers;
